// import React from 'react';
// import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';

// Material-ui
// import { createMuiTheme } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
// import { CssBaseline } from '@material-ui/core';

// // Pages
// import Login from './login';
// import Success from './success';
// import Wellcome from './wellcome';

// Create a theme for the whole app
// const theme = createMuiTheme({
//   palette: {
//     primary: {
//       main: '#6d5eac',
//     },
//     secondary: {
//       main: '#64A7C1',
//     },
//     default: {
//       main: '#ffffff',
//     },
//   },
// });

function App() {
  window.location.replace('https://brand-wallet.com/resources/connections/loyverse');

  return;
  //   return (
  //     <>
  //       <CssBaseline />
  //       <ThemeProvider theme={theme}>
  //         <Router>
  //           <Switch>
  //             <Route exact path="/" component={Login} />
  //             <Route exact path="/wellcome" component={Wellcome} />
  //             <Route exact path="/success" component={Success} />
  //           </Switch>
  //         </Router>
  //       </ThemeProvider>
  //     </>
  //   );
}

export default App;
